import React from 'react';
import '../less/index.less';
import Link from '../../NavigationLink';
import ExchangeRates from '../../ExchangeRates';
import palette from '../../../palette';
import {Menu, MenuItem} from '@ab/components';
import {get} from '../../../config';

const linkStyle = {
        fontWeight: palette.twSemi,
        fontSize: palette.tsSmall,
    },
    menuItemStyle = {
        itemFontWeight: palette.twSemi,
        itemFontSize: palette.tsSmall,
    };

export default function template() {
    let {showMoreServices} = this.state,
        menuContent = null;

    if (showMoreServices) {
        menuContent = (
            <div className="menu-item-overlay">
                <Menu>
                    <Link href="/history">
                        <MenuItem style={menuItemStyle}>
                            {this.l10n('HEADER_MENU_ARCHIVE')}
                        </MenuItem>
                    </Link>
                    <Link href="/inquiry">
                        <MenuItem style={menuItemStyle}>
                            {this.l10n('HEADER_MENU_INQUIRY')}
                        </MenuItem>
                    </Link>
                </Menu>
            </div>
        );
    }

    return (
        <header className={`module-header ${get('TEACHER') ? 'teacher' : ''}`}>
            <div className="content">
                <div className="a-side">
                    <Link href="/" className="logo" />
                    <div className="menu-item">
                        <Link style={linkStyle} href="/">
                            {this.l10n('HEADER_MENU_WALLET')}
                        </Link>
                    </div>
                    <div className="menu-item">
                        <Link style={linkStyle} href="/deposit/my">
                            {this.l10n('HEADER_MENU_DEPOSIT')}
                        </Link>
                    </div>
                    <div className="menu-item">
                        <Link style={linkStyle} href="/credit">
                            {this.l10n('HEADER_MENU_CREDIT')}
                        </Link>
                    </div>
                    <div className="menu-item">
                        <Link style={linkStyle} href="/payments">
                            {this.l10n('HEADER_MENU_PAYMENTS')}
                        </Link>
                    </div>
                    <div className="menu-item">
                        <Link style={linkStyle} href="/transfer/send">
                            {this.l10n('HEADER_MENU_INSTANT_PAYMENTS')}
                        </Link>
                    </div>
                    <div className="menu-item">
                        <Link style={linkStyle} href="/subscriptions">
                            {this.l10n('HEADER_MENU_SUBSCRIPTIONS')}
                        </Link>
                    </div>
                </div>
                <div className="b-side">
                    {get('TEACHER') ? (
                        <div className="teacher-name">
                            {get('SECOND_NAME')}&nbsp;
                            {get('FIRST_NAME')
                                ?.substr(0, 1)
                                .toUpperCase()}
                            .&nbsp;
                            {get('PATRONYMIC')
                                ?.substr(0, 1)
                                .toUpperCase()}
                            .
                        </div>
                    ) : null}
                    <ExchangeRates {...this.props} />
                </div>
            </div>
        </header>
    );
}
